export default "__VITE_ASSET__BUcBdh4Q__"